export { default as Flairs } from './flairs.container';
